export const isInt = n => {
	return Number(n) == n && n % 1 === 0;
};

export const isFloat = n => {
	return Number(n) == n && n % 1 !== 0;
};

export const truncateString = (str, maxLength) => {
	if (str?.length > maxLength) {
		return str.substring(0, maxLength) + '...';
	} else {
		return str;
	}
};
